<template>
  <div id="nav">
    <md-toolbar class="md-dense">
      <h3 class="md-title title" @click="home">JSON Editor</h3>
      <md-button @click.native="about" :class="[isPath('/index.html') || isPath('/') ? active : '']">About</md-button>
      <md-button @click.native="guide" :class="[isPath('/guide.html') ? active : '']">Guide</md-button>
      <md-button @click.native="editor">Editor</md-button>
      <span style="flex: 1;">&nbsp;</span>
      <md-button @click.native="github">
        <md-icon md-iconset="fa fa-github"></md-icon>
      </md-button>
      <md-button @click.native="signIn" v-if="!isSignIn">Sign In</md-button>
      <md-button @click.native="signUp" v-if="!isSignIn">Sign Up</md-button>

      <md-menu v-if="isSignIn" md-align-trigger>
        <md-button md-menu-trigger>My Account</md-button>
        <md-menu-content>
          <md-menu-item @click.native="signOut">Sign Out</md-menu-item>
          <md-menu-item @click.native="changePassword">Change Password</md-menu-item>
          <md-menu-item @click.native="deleteAccount">Delete Account</md-menu-item>
        </md-menu-content>
      </md-menu>
    </md-toolbar>

    <md-dialog ref="deleteAccountDialog">
      <md-dialog-title>Delete Account</md-dialog-title>
      <md-dialog-content>
        Are you sure to delete your account?<br>
        All your stored schemas would be lost!
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click.native="deleteAccountCanceled">Cancel</md-button>
        <md-button class="md-primary" @click.native="deleteAccountConfirmed">Confirm</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import { authentication, repository } from './components/json-editor'

  export default {
    name: 'nav',
    async created () {
      try {
        await authentication.retrieveCurrentUser()
      } catch (err) {}
      this.isSignIn = authentication.currentUser !== null
      authentication.addListener(this.authChanged)
      this.$root.$on('accountStatus', () => {
        this.isSignIn = authentication.currentUser !== null
      })
    },
    data () {
      return {
        isSignIn: false,
        active: 'active'
      }
    },
    methods: {
      authChanged (user) {
        this.isSignIn = user !== null
      },
      /*
       isRoute (route) {
       return this.$route.path === route
       },
       */
      isPath (path) {
        return window.location.pathname === path
      },
      home () {
        if (this.isSignIn) {
          window.location.href = '/editor.html'
        } else {
          window.location.href = '/index.html'
        }
      },
      about () {
        // this.$router.push('/')
        window.location.href = '/index.html'
      },
      guide () {
        // this.$router.push('/guide')
        window.location.href = '/guide.html'
      },
      editor () {
        // this.$router.push('/editor')
        window.location.href = '/editor.html'
      },
      github () {
        window.open('https://github.com/tangram-js/json-editor', '_blank')
      },
      signIn () {
        window.location.href = '/editor.html#/signIn'
      },
      signUp () {
        window.location.href = '/editor.html#/signUp'
      },
      changePassword () {
        window.location.href = '/editor.html#/changePassword'
      },
      async signOut () {
        try {
          await authentication.signOut()
        } catch (err) {}
        this.$nextTick(() => {
          console.log('reload')
          window.location.reload()
        })
      },
      deleteAccount () {
        this.$refs.deleteAccountDialog.open()
      },
      deleteAccountCanceled () {
        this.$refs.deleteAccountDialog.close()
      },
      async deleteAccountConfirmed () {
        // delete account and remove all custom schemas
        try {
          await repository.deleteAllSchemas()
          await authentication.deleteUser()
        } catch (err) {}
        this.$refs.deleteAccountDialog.close()
        this.$nextTick(() => {
          window.location.reload()
        })
      }
    }
  }
</script>

<style scoped>
  #nav {
  }
  .title {
    cursor: pointer;
  }
  .active {
    border-bottom: 1px solid white;
  }
</style>



// WEBPACK FOOTER //
// Nav.vue?24e314ed